import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=3b81db0f&"
import script from "./BigNumber.vue?vue&type=script&lang=ts&"
export * from "./BigNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports